import { useEffect } from 'react';
import '../../../Library.css'; /* Global App */

// import Logo from './svg/LogoV0';

function MobileView() {
  useEffect(() => {
    window.location.href = `https://pages.beatport-lp.com/beatport-dj-mobile`;
    const parent = document.getElementById('DJAPPMM');
    if (parent) {
      parent.style.height = '100%';
    }
  }, [])

  return null;
  // return (
  //   	<div className={'bpc bp-mobile flexColumn space-around'} >
  //       <Logo width={'50%'} color={'white'} height={'auto'} style={{ position: 'absolute', marginTop: -900, zIndex:1 }} />
  //       <div className={'flexColumn'} style={{margin: '0px 40px', gap: 30}}>
  //     		<span style={{ fontSize: '3em', margin: '0px 30px', lineHeight: 'initial' }}>
  //           Sorry, Beatport DJ is currently desktop only
  //     		</span>
  //         <span style={{ color: '#808080', fontSize: '2.1em', lineHeight: 'initial' }}>
  //           You can still download our mobile app. Discover new music and build and edit your playlists, whenever and wherever you want.
  //         </span>
  //         <a href={'https://www.qr.beatport.com/mbl_app_web_app'} style={{textAlign: '-webkit-center', color: 'white', textDecoration: 'none', zIndex:10 }}>
  //           <div style={{ width: 250, fontSize: '2em', border: '1.5px solid #5A5A5A', borderRadius: 4, marginTop: 60, padding: 30 }}>Get the app now</div>
  //         </a> 
  //         <a href={'https://beatport.com'} style={{textAlign: '-webkit-center', color: 'white', textDecoration: 'none', zIndex:10 }}>
  //           <div style={{ width: 250, fontSize: '2em', border: '1.5px solid #5A5A5A', borderRadius: 4, marginTop: 60, padding: 30 }}>Beatport Store</div>
  //         </a>        
  //       </div>
  //     </div>
  // )
}

export default MobileView;
